import { cva } from "cva";
import {
  Separator as RACSeparator,
  type SeparatorProps,
} from "react-aria-components";
import { twMerge } from "tailwind-merge";

export type SeparatorPropsCustom = SeparatorProps & {
  theme?: "default" | "dark";
};

const styles = cva({
  base: "border-0 border-solid",
  variants: {
    theme: {
      default: "border-theme-outline-variant",
      dark: "border-white/12",
    },
    orientation: {
      horizontal: "h-px w-full border-t",
      vertical: "h-full w-px border-l",
    },
  },
  defaultVariants: {
    theme: "default",
    orientation: "horizontal",
  },
});

export function Separator(props: SeparatorPropsCustom) {
  return (
    <RACSeparator
      {...props}
      className={twMerge(
        styles({
          theme: props.theme,
          orientation: props.orientation,
        }),
        props.className,
      )}
    />
  );
}
